// extracted by mini-css-extract-plugin
module.exports = {"desktop_open_sidebar_container":"style_desktop_open_sidebar_container__Wc20a","open":"style_open__bKTL7","closed":"style_closed__AIcZl","placeholder":"style_placeholder__EVwBL"};